import { Dispatch } from 'redux';

import { Events } from 'src/constants/webSocketConsts/events';
import { ApiTags } from 'src/services/api';
import {
  CreditBalanceResponse,
  studioCreditApi,
} from 'src/services/api/studioCreditApi';

// The backend broadcasts the balance row's display subset (the same shape
// GET /credit-balance returns) on every grant/deduction, so we can patch the
// cache in place rather than refetch. updateQueryData is a no-op when the query
// isn't subscribed (user not on the Plans page), which is exactly what we want.
//
// The row does not carry the expiry projection (it is derived from the grant
// trail on read), so the patch keeps the cached projection and a refetch is
// queued to refresh it — also a no-op without a subscriber.
export function handleCreditBalanceUpdate(
  event: Events,
  items: CreditBalanceResponse[],
  dispatch: Dispatch<any>,
) {
  const balance = items.at(0);
  if (!balance) {
    return;
  }

  // The balance row is never deleted; INSERT (first grant) and MODIFY both
  // carry the current balance, so both simply overwrite the cached value.
  if (event !== Events.Insert && event !== Events.Modify) {
    return;
  }

  dispatch(
    studioCreditApi.util.updateQueryData(
      'getCreditBalance',
      undefined,
      (draft) => {
        Object.assign(draft, balance);
      },
    ),
  );
  dispatch(studioCreditApi.util.invalidateTags([ApiTags.creditBalance]));
}
